import React from 'react';
import { Modal } from 'antd';
import ComponentLog from '@/components/component-log';
import Dongdong from '@/components/dongdong';
import { isEffectArray } from '@/common/utils';
import './index.less';

/* *********
 * 详情modal
 ********* */
const CrossDetailModal = (props) => {
  const { modalVisible, setModalVisible, currentRowItem } = props;

  /************** 关闭回调 **************/
  function handleOnCancel() {
    setModalVisible(false);
  }

  return (
    <Modal
      title={`推荐品类详情${'（' + currentRowItem.mainCidName + '&' + currentRowItem.recCidName + '）' || ''}`}
      className="cross-detail-modal-fa"
      width={560}
      bodyStyle={{
        minWidth: '560px',
        maxHeight: '550px',
        overflow: 'hidden auto',
        borderTop: '1px solid rgba(0,0,0,.06)',
      }}
      destroyOnClose={true}
      visible={modalVisible}
      footer={false}
      onCancel={handleOnCancel}
    >
      <div className="cross-detail-modal-wrapper">
        <div className="cross-detail-li cross-detail-title1">综合推荐</div>
        <div className="cross-detail-li cross-detail-title2">
          <span>{currentRowItem?.promScorePer}</span>分
        </div>
        <div className="cross-detail-li cross-detail-title3">（由品类”关联度“&“渗透空间”综合计算得出）</div>
        <div className="cross-detail-li cross-detail-title4"></div>
        <div className="cross-detail-li cross-detail-title5">
          <span className="title-left-top">品类关联度</span>
          <span className="title-left-bottom">
            <span className="rate">{currentRowItem?.refScorePer}分</span>
            <span className="rate-gl">
              关联度{`${currentRowItem?.refPer}%`} <span className="rate-dis">（该值越高评分越高）</span>
            </span>
          </span>
          <span className="title-right-top">品类渗透空间</span>
          <span className="title-right-bottom">
            <span className="rate">{currentRowItem?.permScorePer}分</span>
            <span className="rate-gl">
              <span className="rate-dis">（该值越高评分越低）</span>渗透率{`${currentRowItem?.permPer}%`}
            </span>
          </span>
        </div>
        <div className="cross-detail-li cross-detail-title6">
          <div className="title-fa">指标解读：</div>
          <div className="card1-2-fa">
            <div className="card1-fa">
              <div className="title">什么是品类关联度？</div>
              <div className="content">
                品类关联度是指两个品类共购用户在所有用户中的比例，占比越高则关联度越高。例如：在购买洗发水或购买护发素的用户中，同时购买洗发水和购买护发素的用户越多，则洗发水和护发素关联性越强。
              </div>
            </div>
            <div className="card2-fa">
              <div className="title">什么是品类渗透空间？</div>
              <div className="content">
                品类渗透空间是指品类间的合作机会。品类间渗透率越低，渗透空间得分越高。品类渗透率指关联品类B中购买A品类的用户占比。例如：母婴在图书中的渗透率=（母婴和图书的重合用户）/图书用户。
              </div>
            </div>
          </div>
          <div className="card3-fa">
            <div className="title">*部分数据参考</div>
            {isEffectArray(currentRowItem?.permMsgs)
              ? currentRowItem?.permMsgs?.map((item, index) => (
                  <div className="content1-content2" key={index}>
                    {item}
                  </div>
                ))
              : ''}
          </div>
        </div>
        <div className="cross-detail-li cross-detail-title7">
          <div className="title">品类对接人：</div>
          <div className="erp-list-fa">
            {isEffectArray(currentRowItem?.authorInfos) ? (
              currentRowItem?.authorInfos?.map((item, index) => (
                <ComponentLog key={index}>
                  <span clstag="yx_center_kplyx_1668603027997|5">
                    <Dongdong name={item?.realName} erp={item?.erp} />
                  </span>
                </ComponentLog>
              ))
            ) : (
              <span className="erp-list-no">待补充</span>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CrossDetailModal;
